import React, { useState, useEffect } from 'react'

interface SessionWarningModalProps {
  isOpen: boolean
  onExtendSession: () => void
  onLogout: () => void
  timeRemaining: number // วินาที
}

export const SessionWarningModal: React.FC<SessionWarningModalProps> = ({
  isOpen,
  onExtendSession,
  onLogout,
  timeRemaining: initialTime
}) => {
  const [timeLeft, setTimeLeft] = useState(initialTime)

  useEffect(() => {
    setTimeLeft(initialTime)
  }, [initialTime])

  useEffect(() => {
    if (!isOpen) return

    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          onLogout()
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [isOpen, onLogout])

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60)
    const secs = seconds % 60
    return `${mins}:${secs.toString().padStart(2, '0')}`
  }

  if (!isOpen) return null

  return (
    <div
      className="modal d-block"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        overflowX: 'auto',
        overflowY: 'auto'
      }}
      aria-modal
      aria-labelledby="sessionWarningTitle"
    >
      <div
        className="modal-backdrop show"
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 0,
          opacity: 0.5
        }}
      />
      <div
        className="modal-dialog modal-dialog-centered"
        style={{
          position: 'relative',
          zIndex: 1,
          maxWidth: '400px',
          margin: '1.75rem auto'
        }}
      >
        <div className="modal-content shadow">
          <div className="modal-header border-bottom py-3">
            <div className="d-flex align-items-center gap-2">
              <span
                className="badge bg-warning text-dark rounded-circle d-flex align-items-center justify-content-center"
                style={{ width: 36, height: 36, fontSize: '1.1rem' }}
              >
                !
              </span>
              <div>
                <h5 className="modal-title mb-0" id="sessionWarningTitle">
                  เซสชันจะหมดอายุ
                </h5>
                <small className="text-muted">
                  ระบบจะออกจากระบบอัตโนมัติในอีก <strong>{formatTime(timeLeft)}</strong>
                </small>
              </div>
            </div>
          </div>
          <div className="modal-body py-3">
            <p className="mb-0 text-secondary small">
              หากคุณยังใช้งานอยู่ กรุณากดปุ่ม &quot;ขยายเวลา&quot; เพื่อคงสถานะการเข้าสู่ระบบ
            </p>
          </div>
          <div className="modal-footer border-top py-3 gap-2">
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={onLogout}
            >
              ออกจากระบบ
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={onExtendSession}
            >
              ขยายเวลา
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
